import React from 'react';
import { Button, Spin, Typography } from 'antd';
import moment from 'moment';
import { declOfNum } from '../../../../../helpers/dspx-utils';
import styles from './MeterInfo.module.scss';

const { Text } = Typography;

export const formatDate = (date) =>
  date ? moment(date).format('DD.MM.YYYY') : '-';

export const getContent = (content) => content || '-';

const yearFormatter = new Intl.NumberFormat('en-En', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 1,
});

const convertMonthsToYears = (monthInterval) =>
  yearFormatter.format(monthInterval / 12);

export const getVerificationInterval = (interval) => {
  if (!interval) return '-';

  const yearInterval = convertMonthsToYears(interval);
  const isYearFractional = yearInterval % 1 !== 0;
  const yearIntervalText = isYearFractional
    ? `${yearInterval} года`
    : `${yearInterval} ${declOfNum(yearInterval, ['год', 'года', 'лет'])}`;

  return `${interval} мес. / ${yearIntervalText}`;
};

export const getLastValues = (lastValues, unit, isDate = false) => {
  if (!lastValues?.length) return '-';

  return lastValues.map((lastVal) => {
    return (
      <Text key={lastVal.tariffId}>
        {lastVal.tariffName && (
          <Text className={styles.accent}>{lastVal.tariffName}: </Text>
        )}

        {isDate ? (
          formatDate(lastVal.date)
        ) : (
          <>
            {lastVal.value || '-'}
            {unit ? ` ${unit}` : ''}
          </>
        )}
      </Text>
    );
  });
};

export const getDownloadActContent = ({ meter, url, loading }) => {
  if (!url && !loading) return '-';

  const serialNumber = meter?.serialNumber ? ` №${meter.serialNumber}` : '';
  const ext = meter?.actFileName?.split('.').pop();
  const extText = ext ? `.${ext}` : '';

  return (
    <Button
      type="link"
      loading={loading}
      disabled={loading}
      href={url || '#'}
      download={`Акт ввода в эксплуатацию счетчика${serialNumber}${extText}`}
      className={styles.download}
    >
      {!loading && 'Скачать'}
    </Button>
  );
};
